import certificationService from '@/services/certification';
import store from '@/store/index.js';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    certification: null,
  };
};
const state = initialState();

const getters = {
  certification() {
    return state.certification;
  },
};

const actions = {
  async getCertificationById({commit}, id) {
    try {
      const result = await certificationService.getCertificationById(id);
      commit('setCertification', result);
      return result;
    } catch (error) {
      store.commit('env/setIsNotFound', true);
    }
  },
};

const mutations = {
  setCertification(state, data) {
    state.certification = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
